import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, Process, Clients, Compositions } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Services />
        <Compositions />
        <Process />
        <Testimonials />
        <Team />
        <Clients />

      </section>

    </>
  );
}

export default AboutUs;